import './App.css';

import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

export default function App() {
  const styles = {
  	position: 'absolute',
  	top: '40%',
  	left: '50%',
  	transform: 'translate(-50%, -50%)',
		color: '#fff',
  };

	const footer = {
		position: 'fixed',
		left: '0',
		bottom: '0',
		width: '100%',
		backgroundColor: '#b0bbcf',
		color: 'white',
		textAlign: 'center',
	};

  const particlesInit = async (main) => {
    console.log(main);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(main);
  };

  return (
    <div className="App">
			<div style={styles}>
				<h1>
					Kapman East Africa
				</h1>
				<p>
					Comprehensive technology solutions for the East Africa region 
				</p>
				<p>
					With expertise in artificial intelligence and data analysis, we bring the latest innovations to every project
				</p>
			</div>

       <Particles
      id="tsparticles"
      init={particlesInit}

      options={{
        "fullScreen": {
            "enable": true,
            "zIndex": -1
        },
        "particles": {
            "number": {
                "value": 15,
                "density": {
                    "enable": false,
                    "value_area": 400
                }
            },
            "color": {
                "value": "#fff"
            },
            "shape": {
                "type": "circle",
            },
            "opacity": {
                "value": 0.5,
                "random": false,
                "anim": {
                    "enable": false,
                    "speed": 1,
                    "opacity_min": 0.1,
                    "sync": false
                }
            },
            "size": {
                "value": 4,
                "random": false,
                "anim": {
                    "enable": false,
                    "speed": 10,
                    "size_min": 0.1,
                    "sync": false
                }
            },
            "rotate": {
                "value": 0,
                "random": true,
                "direction": "clockwise",
                "animation": {
                    "enable": true,
                    "speed": 3,
                    "sync": false
                }
            },
            "line_linked": {
                "enable": false,
                "distance": 600,
                "color": "#ffffff",
                "opacity": 0.4,
                "width": 2
            },
            "move": {
                "enable": true,
                "speed": 1,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 1200
                }
            }
        },
        "interactivity": {
            "events": {
                "onhover": {
                    "enable": true,
                    "mode": ["grab"]
                },
                "resize": true
            },
            "modes": {
                "grab": {
                    "distance": 400,
                    "line_linked": {
                        "opacity": 0.5
                    }
                },
                "bubble": {
                    "distance": 400,
                    "size": 40,
                    "duration": 2,
                    "opacity": 8,
                    "speed": 3
                },
                "repulse": {
                    "distance": 200
                },
                "push": {
                    "particles_nb": 4
                },
                "remove": {
                    "particles_nb": 2
                }
            }
        },
        "retina_detect": true,
        "background": {
            "color": "#706c6c",
            "position": "50% 50%",
            "repeat": "no-repeat",
            "size": "cover"
        }
    }}
    />
		<div style={footer}>
			<p>Contact us: <a href="mailto:enquiries@kapman-ea.com">enquiries@kapman-ea.com</a></p>
		</div>
    </div>
  );
}
